<template>
    <section class="sidebar" :class="{'nav-toggle-active': showLeftNav}">
        <div class="aside-bar">
            <div class="row g-0">
                <div class="col-auto">
                    <div class="aside-bar-content-icons">
                        <div class="navigation-bar">
                            <div class="logo2">
                                <a href="/">
                                    <img src="/images/logo2.svg" alt="HelmBay">
                                </a>
                            </div>
                            <div class="sidebar-menu">
                                <ul class="nav-bar">
                                    <li class="navigation-item" :class="(activeMenu == 'repositories')?'active':''">
                                        <inertia-link :href="route('home')" title="Repository">
                                            <i class="demo-icon icon-repository"></i>
                                            <span class="navbar-content">
                                                Repositories
                                            </span>
                                        </inertia-link>
                                    </li>
                                    <li class="navigation-item" :class="(activeMenu == 'api-tokens')?'active':''">
                                        <inertia-link :href="route('api-tokens.index')" title="Repository">
                                            <i class="feather-cpu"></i>
                                            <span class="navbar-content">
                                                API Keys
                                            </span>
                                        </inertia-link>
                                    </li>
                                    <li class="navigation-item" :class="(activeMenu == 'billing')?'active':''">
                                        <a href="/billing">
                                            <i class="feather-file-text"></i>
                                            <span class="navbar-content">
                                                Billing
                                            </span>
                                        </a>
                                    </li>
                                    <li class="navigation-item">
                                        <a href="https://helmbay.com/docs">
                                            <i class="feather-book"></i>
                                            <span class="navbar-content">Docs</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="logout-profile-section">
                            <ul class="bottom-navbar-content">
                                <li>
                                    <a class="logoutLink" title="Logout">
                                        <form @submit.prevent="logout">
                                            <button class="btn_class_logout">
                                                <i class="feather-log-out"></i>
                                                <span class="navbar-content">Logout</span>
                                            </button>
                                        </form>
                                    </a>
                                </li>
                                <li :class="(activeMenu == 'profile')?'active':''">
                                    <inertia-link :href="route('profile.show')">
                                        <img :src="$page.props.user.profile_photo_url" alt="User profile"
                                             class="john_img">
                                        <span class="navbar-content username_class">
                                            {{ $page.props.user.username }}
                                        </span>
                                    </inertia-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <slot name="submenu"></slot>
                </div>
            </div>
        </div>
        <div class="mbHeader d-lg-none">
            <div class="row align-items-center">
                <div class="col">
                    <a href="javascript:void(0)"><img src="/images/logo-icon.svg" alt="..."></a>
                </div>
                <div class="col-auto">
                    <span class="mvNavToggle nav-toggle" v-on:click="toggleMenu">
                        <span></span>
                    </span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        props: ['activeMenu'],
        data() {
            return {
                showLeftNav: false,
            }
        },
        methods: {
            toggleMenu() {
                this.showLeftNav = !this.showLeftNav;
            },
            logout() {
                this.$inertia.post(route('logout'));
            },
        }
    }
</script>
